import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { UpdateAttendanceStatusRequestDto } from "../generated/generatedTypes";

const updateAttendanceStatus = async (
  reservationId: number,
  data: UpdateAttendanceStatusRequestDto
): Promise<void> => {
  const response = await apiFetch(`api/reservation/${reservationId}/attendanceStatus`, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorBody = await response.text();
    console.error("Update attendance status error:", errorBody);
    throw new Error(
      `PUT api/reservation/${reservationId}/attendanceStatus failed with status ${response.status}`
    );
  }
};

export function useUpdateAttendanceStatus() {
  const queryClient = useQueryClient();

  return useMutation<
    void,
    Error,
    { reservationId: number; data: UpdateAttendanceStatusRequestDto }
  >({
    mutationFn: ({ reservationId, data }) => updateAttendanceStatus(reservationId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["myUpcomingReservations"] });
      queryClient.invalidateQueries({ queryKey: ["myPastReservations"] });
    },
    onError: (error) => {
      console.error("Error updating attendance status:", error.message);
    },
  });
}
